import { ButtonPosition } from '@/common/manager/position/button-position';
export const config = {
    value: 'formReRender',
    position: [ButtonPosition.filterEvent],
    action: (arg) => {
        const { buttonConfig, _context } = arg || {};
        const { options = {} } = buttonConfig;
        const { _bindForm } = options;
        function reloadOneForm(id) {
            if (typeof id === 'string') {
                const form = _context.$(id);
                form?.reRender()?.();
            }
        }
        if (_bindForm && _context) {
            if (Array.isArray(_bindForm)) {
                _bindForm.forEach((item) => {
                    reloadOneForm(item);
                });
            }
            else {
                reloadOneForm(_bindForm);
            }
        }
    },
};
